export const crmTypes = {
  SALESFORCE: 'Salesforce',
  HUBSPOT: 'Hubspot',
};

export const crmTypesToStringMap = {
  [crmTypes.SALESFORCE]: 'Salesforce Push',
  [crmTypes.HUBSPOT]: 'HubSpot Push',
};
